export default {
	title: {
		inner: 'Bandara'
	},
	meta: {
		metaDescription: '',
		ogTitle: '',
		ogType: 'website',
		ogImage: '',
		ogUrl: '',
		ogDescription: '',
		ogLocale: 'de'
	},
	link: {
		'en-us': '/en',
		'de-ch': '/',
		canonical: '/'
	}
}



// WEBPACK FOOTER //
// ./src/utils/defaultHeadData.js